import { CloseCircleOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Form, Input, Tooltip } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { adAccountStores } from "./AdAccountStores";
import { pick } from "lodash";

export const AdAccountForm = ({ onCancel, acc }) => {
  const { t } = useTranslation();
  const [form] = useForm();

  useEffect(() => {
    setTimeout(() => form.setFieldsValue(pick(acc, ["account_name", "description"])));
  }, [acc, form]);

  const onSave = async () => {
    const formData = await form.validateFields();
    await adAccountStores.saveAdvertiser(formData, acc?.id);
    window.AirflexJS.logEvent("save_ad_account", { id: acc?.id });
    onCancel();
  };

  return (
    <Form form={form} layout="vertical">
      <div className="flex gap-2">
        <Tooltip title={t("Cancel")}>
          <Button type="ghost" className="px-0 rounded-full text-tgray" onClick={onCancel}>
            <CloseCircleOutlined className="text-base" />
          </Button>
        </Tooltip>
        <Form.Item name="account_name" rules={[{ required: true }]} className="mb-0 flex-[1]">
          <Input placeholder={t("Name")} />
        </Form.Item>
        <Form.Item name="description" className="mb-0 flex-[2]">
          <Input placeholder={t("Description")} />
        </Form.Item>
        <Tooltip title={t("Save")}>
          <Button type="primary" className="px-2" onClick={onSave}>
            <SaveOutlined />
          </Button>
        </Tooltip>
      </div>
    </Form>
  );
};
